import { clearSession } from "./SessionStorage.js";

// Local part of every logout: empty auth and no stored token. No network, no navigation.
const clearStoredSession = (setAuth) => {
  setAuth({});
  clearSession("authToken");
};

export default clearStoredSession;
